import type { FC } from "react"

import { useUpdateGoodsReceipt } from "../subfeatures/Incoming/hooks"

import { ConfirmationDialog } from "@/components/common/Modals"
import type { GoodsReceipt } from "@/graphql/codegen/graphql"

interface GoodsReceiptDeleteConfirmationProps {
  goodsReceipt: GoodsReceipt
  onClose: () => void
  onSuccess?: () => void
}

export const GoodsReceiptDeleteConfirmation: FC<GoodsReceiptDeleteConfirmationProps> = ({
  goodsReceipt,
  onClose,
  onSuccess,
}) => {
  const { update: deleteGoodsReceipt } = useUpdateGoodsReceipt({
    successMessage: "Advanced Goods Receipt successfully deleted.",
  })

  const handleConfirmDelete = async (): Promise<void> => {
    await deleteGoodsReceipt({
      goodsReceiptId: goodsReceipt.goodsReceiptId,
      isDeleted: true,
      warehouseId: goodsReceipt.warehouseArea?.warehouseAreaId as string,
    })

    onClose()
    onSuccess?.()
  }

  return (
    <ConfirmationDialog
      title='Delete Advanced Goods Receipt'
      content='Are you sure you want to delete this advanced goods receipt? This action cannot be undone.'
      closeLabel='Cancel'
      confirmLabel='Yes, Delete'
      onClose={onClose}
      onConfirm={handleConfirmDelete}
      isWarning
    />
  )
}
